@if (callToActionItem) {
    <div
        class="pinned-cta"
        [websiteSticky]="isStickyActive()"
        [stickySlot]="stickySlot"
        [stickyPositionType]="'fixed'"
        [stickyShouldApplyTop]="false"
        data-application="pinned-cta"
        [ngClass]="{
            'pinned-cta--hidden': isCtaHidden(),
            'pinned-cta--hidde-on-mobile': pinnedCtaData.isHeaderExisted,
            'pinned-cta--initial-position': pinnedCtaData.isBannerExisted,
        }"
        websiteTheme
        [colorScheme]="colorScheme"
    >
        <a [href]="pathToRootLocalHomePage" class="pinned-cta__logo" data-application="pinned-cta-logo-link">
            <website-image
                data-application="pinned-cta-logo"
                [src]="'/tp/static/assets/img/header-v2/wrike-logo-' + theme + '-v2' + '.svg'"
                [alt]="'Wrike logo'"
                class="pinned-cta__logo-image"
                [config]="imageConfig"
                [width]="124"
                [height]="60"
            ></website-image>
        </a>
        <div [attr.data-application]="'call-to-actions-' + callToActionItem.content">
            <button
                class="pinned-cta__button"
                website-button-v3
                (click)="openFormPopup()"
                [buttonStyleProperties]="buttonStyleProperties()"
            >
                {{ callToActionItem.ctaFields.buttonOpenModalText }}
            </button>
        </div>
    </div>
}
